import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import CopyFieldIcon from "components/CopyField/Icon";

import { CellComponentProps } from "../types";

type ApiKeysListItemIdCellProps = CellComponentProps;

const ApiKeysListItemIdCell = ({ apiKey }: ApiKeysListItemIdCellProps) => {
  return (
    <Box direction="row" align="center" gap="small">
      <TextEllipsis tooltip={apiKey.id} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Typography {...props} tag="span" variant="p-body3">
            {apiKey.id}
          </Typography>
        )}
      </TextEllipsis>
      <CopyFieldIcon title="Copy" value={apiKey.id} />
    </Box>
  );
};

export default ApiKeysListItemIdCell;
